import { c as _c } from "react/compiler-runtime";
import { DeleteIcon, MenuItem } from "@flat-ui";
import { DeleteProject } from "@pages/project-details/project-overview/delete-project";
import { useState } from "react";
import { DeleteSnapshot } from "@pages/project-details/project-snapshots/delete-snapshot";
/** Renders a red "Delete" menu item and manages the delete confirmation dialog */
export function DeleteMenuItem(props) {
  const $ = _c(7);
  const [shouldShowDeleteDialog, setShouldShowDeleteDialog] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <MenuItem label="Delete" Icon={DeleteIcon} color="error.main" highlightColor="error.main" onClick={() => {
      setShouldShowDeleteDialog(true);
    }} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props.entity || $[2] !== props.type || $[3] !== shouldShowDeleteDialog) {
    t1 = shouldShowDeleteDialog && (props.type === "project" ? <DeleteProject project={props.entity} onClose={() => {
      setShouldShowDeleteDialog(false);
    }} /> : <DeleteSnapshot snapshot={props.entity} onClose={() => {
      setShouldShowDeleteDialog(false);
    }} />);
    $[1] = props.entity;
    $[2] = props.type;
    $[3] = shouldShowDeleteDialog;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <>{t0}{t1}</>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}